import React, { useState } from 'react';
import { getBallotOptionLabel } from './VoteTypeUtils.js'

export const VoteIBPSA = ({ options, hasVoted, onOptionsUpdate, group }) => {
    const [isAffiliateSelectAll, setAffiliateSelectAll] = useState(false)

    const handleSelect = (event, updateOption) => {
        let optionId = parseInt(event.target.value)

        // Find and update option
        const ibpsaOptions = [...options]
        for (let i = 0; i < ibpsaOptions.length; i++) {
            ibpsaOptions[i] = { ...ibpsaOptions[i] }
            if (ibpsaOptions[i].ballotOptionId === optionId) {
                // Toggle score
                ibpsaOptions[i].score = ibpsaOptions[i].score === 1 ? 0 : 1

                if (updateOption) {
                    updateOption(ibpsaOptions[i], ibpsaOptions)
                }
            }
        }

        // Notify update
        onOptionsUpdate(ibpsaOptions)
    }

    const handleAttendSelect = (event) => {
        handleSelect(event, (option, options) => {
            option.ibpsaGroup = null

            // Ensure proxy score cleared
            for (let i = 0; i < options.length; i++) {
                if (options[i].ballotOptionId === proxyOption.ballotOptionId) {
                    options[i].score = 0
                }
            }
        })
    }

    const handleProxySelect = (event) => {
        handleSelect(event, (option, options) => {
            // Ensure attend score cleared
            for (let i = 0; i < options.length; i++) {
                if (options[i].ballotOptionId === attendOption.ballotOptionId) {
                    options[i].score = 0
                }
            }
        })
    }

    const handleAffiliateSelect = (event) => {
        // If any affiliate click clear the select all
        setAffiliateSelectAll(false)

        handleSelect(event)
    }

    const handleAffiliateSelectAll = () => {
        let newSelectAll = !isAffiliateSelectAll

        // Toggle checkbox
        setAffiliateSelectAll(newSelectAll)

        // Toggle all options
        const allOptions = [...options]
        for (let i = 0; i < allOptions.length; i++) {
            allOptions[i] = { ...allOptions[i] }
            if (allOptions[i].ibpsaGroup === "Affiliate Directors") {
                allOptions[i].score = newSelectAll === true ? 1 : 0
            }
        }

        // Notify update
        onOptionsUpdate(allOptions)
    }

    const handleProxyUpdate = (event) => {
        const allOptions = [...options]
        for (let i = 0; i < allOptions.length; i++) {
            allOptions[i] = { ...allOptions[i] }
            if (allOptions[i].ballotOptionId === proxyOption?.ballotOptionId) {
                allOptions[i].ibpsaGroup = event.target.value
            }
        }

        // Notify update
        onOptionsUpdate(allOptions)
    }

    let attendOption = options.find(option => option.ballotOptionName === "Attend")
    let proxyOption = options.find(option => option.ballotOptionName === "Proxy")

    return (
        <>
            <p className="text-2xl mb-4">AT LARGE DIRECTORS</p>
            <p className="mb-4">Vote for up to {group.maximumVotes} of the following candidates by clicking the box next to the candidate's name.</p>
            {options.filter(option => option.ibpsaGroup === "At Large Directors").map((option) =>
                <div key={option.ballotOptionId} className="mb-4 flex">
                    <input type="checkbox"
                        id={option.ballotOptionName}
                        value={option.ballotOptionId}
                        disabled={hasVoted}
                        checked={option.score > 0}
                        onChange={handleSelect} />
                    <label htmlFor={option.ballotOptionName}
                        className="cursor-pointer disabled:cursor-default flex-1">{getBallotOptionLabel(group, option)}</label>
                </div>
            )}

            <p className="text-2xl mb-4">AFFILIATE DIRECTORS</p>
            <p className="mb-4">Each Affiliate can nominate a Director to represent the Affiliate on the Board. These Affiliate Directors have been nominated this year and are listed below. Although these are not contested positions, the membership does have the opportunity to accept/reject these candidates. To accept all these nominations, you can select "Vote for the entire slate" or select individuals.</p>

            <div className="mb-4 flex">
                <input type="checkbox"
                    id="affiliate-select-all"
                    value={isAffiliateSelectAll}
                    disabled={hasVoted}
                    checked={isAffiliateSelectAll === true}
                    onChange={handleAffiliateSelectAll} />
                <label htmlFor="affiliate-select-all"
                    className="cursor-pointer disabled:cursor-default flex-1 font-medium">Vote for the entire slate</label>
            </div>

            <p className="mb-4">Or,<br />Vote individually for:</p>

            {options.filter(option => option.ibpsaGroup === "Affiliate Directors").map((option) =>
                <div key={option.ballotOptionId} className="mb-4 flex">
                    <input type="checkbox"
                        id={option.ballotOptionName}
                        value={option.ballotOptionId}
                        disabled={hasVoted}
                        checked={option.score > 0}
                        onChange={handleAffiliateSelect} />
                    <label htmlFor={option.ballotOptionName}
                        className="cursor-pointer disabled:cursor-default flex-1">{getBallotOptionLabel(group, option)}</label>
                </div>
            )}

            <p className="text-2xl mb-4">MEMBER RESPONSE FORM</p>
            <p className="mb-4">The AGM will be held in person and online at TU Wien in Vienna, Austria, Friday 9th October 2026 at 14:00 CEST (12:00 UTC).</p>

            {attendOption &&
                <div key={attendOption.ballotOptionId} className="mb-4 flex">
                    <input type="radio"
                        id={attendOption.ballotOptionName}
                        value={attendOption.ballotOptionId}
                        disabled={hasVoted}
                        checked={attendOption.score > 0}
                        onChange={handleAttendSelect}
                        className="align-top" />
                    <label htmlFor={attendOption.ballotOptionName}
                        className="cursor-pointer disabled:cursor-default flex-1">I plan to attend the IBPSA Annual General Meeting of the Members specified above.</label>
                </div>
            }

            {proxyOption &&
                <div key={proxyOption.ballotOptionId} className="mb-4 flex">
                    <input type="checkbox"
                        id={proxyOption.ballotOptionName}
                        value={proxyOption.ballotOptionId}
                        disabled={hasVoted}
                        checked={proxyOption.score > 0}
                        onChange={handleProxySelect}
                        className="align-top" />
                    <label htmlFor={proxyOption.ballotOptionName}
                        className="cursor-pointer disabled:cursor-default flex-1">I appoint
                        <input type="text"
                            id={proxyOption.ballotOptionId}
                            disabled={hasVoted}
                            onChange={handleProxyUpdate}
                            value={proxyOption.ibpsaGroup != null ? proxyOption.ibpsaGroup : ''}
                            className="inline w-72 mx-2 py-1" />
                        as my proxy to attend, act and vote for and on my behalf at Annual General Meeting of the Members specified above.
                        If no person is named or fails to attend the Annual General Meeting of the Members specified above, then I appoint Peter de Wilde (Vice-President), or failing him, Danielle Monfet (Secretary) as my proxy to attend, act and vote for and on my behalf.

                        I grant authority to the proxy holder to vote in his/her discretion in respect to any matter considered at the meeting.</label>
                </div>
            }

            <p className="mb-4">I hereby consent to the Annual General Meeting of the Members being held outside Canada, and at the location specified above.</p>
            <p className="mb-4">Proxies submitted here may be withdrawn or modified via email notice to <a href="mailto:proxy@ibpsa.org">proxy@ibpsa.org</a>. Proxies may also be withdrawn at the meeting in the event you attend.</p>
        </>
    );
}